var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{ref:"form",attrs:{"novalidate":"","autocomplete":_vm.autocomplete},on:{"valid":function($event){return _vm.$emit('valid')},"invalid":function($event){return _vm.$emit('invalid')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }